export function getMarket(lat, lng) {
  if (lat > 40.4 && lat < 41.0 && lng > -74.5 && lng < -73.5) return ["New York Metro", 1.45];
  if (lat > 33.5 && lat < 34.5 && lng > -118.8 && lng < -117.5) return ["Los Angeles", 1.38];
  if (lat > 37.2 && lat < 38.0 && lng > -122.8 && lng < -121.5) return ["San Francisco Bay", 1.42];
  if (lat > 47.0 && lat < 48.0 && lng > -122.8 && lng < -121.5) return ["Seattle", 1.35];
  if (lat > 41.5 && lat < 42.2 && lng > -88.5 && lng < -87.2) return ["Chicago", 1.22];
  if (lat > 39.4 && lat < 40.2 && lng > -105.2 && lng < -104.5) return ["Denver", 1.18];
  if (lat > 32.5 && lat < 33.5 && lng > -97.5 && lng < -96.5) return ["Dallas", 1.10];
  if (lat > 29.5 && lat < 30.2 && lng > -95.8 && lng < -94.8) return ["Houston", 1.12];
  if (lat > 33.5 && lat < 34.3 && lng > -84.8 && lng < -83.8) return ["Atlanta Metro", 1.08];
  if (lat > 33.0 && lat < 34.0 && lng > -112.5 && lng < -111.5) return ["Phoenix", 1.05];
  if (lat > 25.5 && lat < 26.5 && lng > -80.5 && lng < -80.0) return ["Miami", 1.15];
  if (lat > 35.0 && lat < 35.6 && lng > -81.0 && lng < -80.5) return ["Charlotte", 1.06];
  if (lat > 35.9 && lat < 36.5 && lng > -87.0 && lng < -86.5) return ["Nashville", 1.07];
  return ["Your Market", 1.0];
}
